import React, { useEffect, useState } from 'react';
import { useStoreState } from 'pullstate';
//Header Data
import headerLogo from '../assets/desall_logo.png';
import styles from './chooseUsername.module.scss';

//Footer Data
import footerImg from '../assets/footer_placeholder_transparent.png';
//Assets

//Components

import AppFooter from '../components/AppFooter/AppFooter';

import DslStore from '../store/DslStore';
import { getFooterMenu, getHeaderMenu } from '../store/Selectors';

import AppHeader from '../components/AppHeader/AppHeader';
import { useForm } from 'react-hook-form';
import { CreateFacebookUser, CreateTwitterUser, SignUpSocialForm } from '../global';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';
import axiosHelper from '../helpers/axiosHelper';
import { useAuth } from '../context/AuthContext';
import { ROUTEPATHS } from './routePaths';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Header } from 'axios-cache-interceptor';
import { Footer } from 'react-day-picker';
import AppHeaderWLF from '../components/AppHeader/AppHeaderWLF';

interface FormData {
  email: string;
  cleartextPassword: string;
  confirmPassword: string;
}
interface UserData {
  id: number;
  objecttype: string;
  email: string;
  firstName: string;
  language: string;
  lastName: string;
  userType: string;
}

const ResetActivate = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [isReset] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [token, setToken] = useState<string>(params.token || '');
  const [data, setData] = useState<UserData>();
  const [activated, setActivated] = useState<boolean>(false);
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm<FormData>();
  const [passwordShown, setPasswordShown] = useState(false);
  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const savePassword = async (password: string) => {
    if (data?.id !== undefined) {
      try {
        const result = await axiosHelper.setNewPassword(data!.id, password, token);

        if (result.data.dslToken !== undefined) {
          setActivated(true);
        }
      } catch (error) {
        //TODO gestire il caso...
      }
    }
  };

  const onSubmit = (values: FormData) => {
    if (values.cleartextPassword === values.confirmPassword) {
      savePassword(values.cleartextPassword);
    }
  };

  const [modalVisible, setModalVisible] = useState<boolean>(false);

  useEffect(() => {
    console.log(token);
    const fetchData = async () => {
      // console.log(token);
      if (token !== '') {
        try {
          const result = await axiosHelper.reset(token);
          setData(result.data);
        } catch (error: any) {
          if (error.response?.status === 401) {
            navigate('/');
          }
          if (error.response?.status === 410) {
            setIsExpired(true);
          }
          //setError(error);
        }
      }
    };
    fetchData();
    window.scrollTo(0, 0);
  }, [token, isReset]);

  return (
    <>
      <AppHeaderWLF links={headerMenu} bgColor="#7997c5" logoImg={headerLogo} alpha={0} pageTitle="Change password" hideSearch={true} />
      <main className="container-fluid py-5 bg-light-gray" >
        <div className="container ">
          {isExpired ? (
            <div className="row justify-content-center">
              <div className="col-12 col-md-4 col-lg-3">
                <div className="row">
                  <div className="col-12 text-center">
                    <h1 className="sub-title color-dark my-5">Sorry</h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-center mb-5">Your reset link has expired. Please try again.</div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row justify-content-center">
                <div className="col-12 col-md-4 col-lg-3">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h1 className="sub-title color-dark my-5">Select a new password</h1>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <input autoComplete="username" type="hidden" {...register('email')} />
                        <input
                          type={passwordShown ? 'text' : 'password'}
                          autoComplete="new-password"
                          placeholder="Your new password"
                          {...register('cleartextPassword', {
                            required: 'Password is required',
                            minLength: { value: 6, message: 'Password must be at least 6 characters long' },
                          })}
                        />
                      </div>
                      <div className="col-12 d-flex justify-content-center mb-5">
                        {errors.cleartextPassword && (
                          <span className="color-red fw-bold">
                            <FontAwesomeIcon icon={faCircleExclamation as IconProp} className="me-2" />
                            {errors.cleartextPassword.message}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <input
                          type={passwordShown ? 'text' : 'password'}
                          autoComplete="new-password"
                          placeholder="Repeat password"
                          {...register('confirmPassword', {
                            validate: (value) => value === watch('cleartextPassword') || 'Passwords do not match',
                          })}
                        />
                      </div>
                      <div className="col-12 d-flex justify-content-center mb-5">
                        {errors.confirmPassword && (
                          <span className="color-red fw-bold">
                            <FontAwesomeIcon icon={faCircleExclamation as IconProp} className="me-2" />
                            {errors.confirmPassword.message}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="row justify-content-center">
                      <div className="col-12 my-5">
                        <button className="btn-dark-blue full rounded 3">Save</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      </main>

      <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
    </>
  );
};
export default ResetActivate;
